import { render, staticRenderFns } from "./UploadChargeDocuments.vue?vue&type=template&id=4b065682&scoped=true&"
import script from "./UploadChargeDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadChargeDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UploadChargeDocuments.vue?vue&type=style&index=0&id=4b065682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b065682",
  null
  
)

export default component.exports